(function () {
  if (window.__moxFacetsTitleCaseBound) return;
  window.__moxFacetsTitleCaseBound = true;

  function titleCaseFacetLabels(root) {
    const scope = root || document;

    scope.querySelectorAll('.hdt-facets-label > span:first-of-type').forEach((span) => {
      const original = (span.textContent || '').trim();
      if (!original) return;

      // Evita reprocesar innecesario
      if (span.dataset.moxTitlecased === original) return;
      span.dataset.moxTitlecased = original;

      // Normaliza: primera letra mayúscula, resto minúscula
      // Nota: si empieza con número (1HORA) quedará 1hora.
      const first = original.charAt(0);
      const rest  = original.slice(1);

      span.textContent = first.toUpperCase() + rest.toLowerCase();
    });
  }

  // 1) Primera pasada
  document.addEventListener('DOMContentLoaded', function () {
    titleCaseFacetLabels(document);
  });

  // 2) Reaplicar cuando Ecomus re-renderiza facets (Ajax / replace DOM)
  const target = document.body;
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        // Si agregaron algo relacionado a facets, aplicamos
        if (
          node.matches?.('.hdt-filter-group__list, .hdt-filter-group__list-item, .hdt-facets-label') ||
          node.querySelector?.('.hdt-facets-label')
        ) {
          titleCaseFacetLabels(node);
        }
      }
    }
  });

  mo.observe(target, { childList: true, subtree: true });
})();
